import * as React from 'react';
import { ModulesBasic, IPropsBasic, ModulesRoot } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import ModulesRoute, { Switch } from './Modules.Route';

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    
}

/** 收件箱 */
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class InBox extends ModulesBasic<IProps, ModulesState> {
    /**
     * 保存单据列表搜索条件记录
     */
    public static SearchDetail: {
        pageNum: number;
        pageSize: number;
        keyword: string;
        saveKeyword: string;
        filterList: {
            issueDateBegin?: number;
            issueDateEnd?: number;
            documentType?: string[];
            lastModifyTimeBegin?: number;
            lastModifyTimeEnd?: number;
            role?: string[];
            status?: string[];
            isArchived?: boolean;
        };
    } = {
        pageNum: 1,
        pageSize: 20,
        keyword: undefined,
        saveKeyword: undefined,
        filterList: {
            issueDateBegin: undefined,
            issueDateEnd: undefined,
            documentType: [],
            lastModifyTimeBegin: undefined,
            lastModifyTimeEnd: undefined,
            role: [],
            status: [],
            isArchived: false,
        },
    };

    public state: ModulesState = new ModulesState();

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentWillUnmount(){
        InBox.SearchDetail = {
            pageNum: 1,
            pageSize: 20,
            keyword: undefined,
            saveKeyword: undefined,
            filterList: {
                issueDateBegin: undefined,
                issueDateEnd: undefined,
                documentType: [],
                lastModifyTimeBegin: undefined,
                lastModifyTimeEnd: undefined,
                role: [],
                status: [],
                isArchived: false,
            },
        };
    }

    render() {
        return (
            <ModulesRoot action={ModulesAction}>
                <Switch>
                    {ModulesRoute.getChildReact('/workbench/platform/document/documentList')}
                </Switch>
            </ModulesRoot>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/index.tsx